import PopupMenu from './PopupMenuLinks';

const keyCode = Object.freeze({
    'TAB': 9,
    'RETURN': 13,
    'ESC': 27,
    'SPACE': 32,
    'PAGEUP': 33,
    'PAGEDOWN': 34,
    'END': 35,
    'HOME': 36,
    'LEFT': 37,
    'UP': 38,
    'RIGHT': 39,
    'DOWN': 40
});

const mediaBreakPoint = '(max-width: 1024px)';
const mq = window.matchMedia(mediaBreakPoint);

class MenubarItem { 
    constructor(domNode, menuObj) {
        this.menu = menuObj;
        this.domNode = domNode;
        this.popupMenu = false;
        
        this.hasFocus = false;
        this.hasHover = false;
        
        this.isMenubarItem = true;        
        
        this.isMenuMobileStyle = false;
        
        this.clickHandler = this.handleClick.bind(this);
        this.keydownHandler = this.handleKeydown.bind(this);
        this.focusHandler = this.handleFocus.bind(this);
        this.blurHandler = this.handleBlur.bind(this);
        this.mouseoverHandler = this.handleMouseover.bind(this);
        this.mouseoutHandler = this.handleMouseout.bind(this);
        this.ESCPressHandler = this.handleESCPress.bind(this);
    }
    
    init() {
        this.domNode.tabIndex = -1;

        if (mq.matches) {
            this.isMenuMobileStyle = true;
            this.addListeners(true);
        } else if (!mq.matches) {
            this.isMenuMobileStyle = false;
            this.addListeners(false);
        }
        window.addEventListener('resize', this.handleWindowResize.bind(this));

        // Initialize pop up menus
        const nextElement = this.domNode.nextElementSibling;
        if (nextElement && (nextElement.tagName === 'UL' || nextElement.classList.contains('mega-menu'))) {
            this.popupMenu = new PopupMenu(nextElement, this);
            this.popupMenu.init();
        }
    }
      
    addListeners(mobile) {
        if (mobile) {
            this.domNode.addEventListener('click', this.clickHandler);

            this.domNode.removeEventListener('keydown', this.keydownHandler);
            this.domNode.removeEventListener('focus', this.focusHandler);
            this.domNode.removeEventListener('blur', this.blurHandler);
            this.domNode.removeEventListener('mouseover', this.mouseoverHandler);
            this.domNode.removeEventListener('mouseout', this.mouseoutHandler);
        } else {
            this.domNode.removeEventListener('click', this.clickHandler);

            this.domNode.addEventListener('keydown', this.keydownHandler);
            this.domNode.addEventListener('focus', this.focusHandler);
            this.domNode.addEventListener('blur', this.blurHandler);
            this.domNode.addEventListener('mouseover', this.mouseoverHandler);
            this.domNode.addEventListener('mouseout', this.mouseoutHandler);
            document.addEventListener('keydown', this.ESCPressHandler);
        }
    }

    handleWindowResize() {
        if (mq.matches && !this.isMenuMobileStyle) {
            this.isMenuMobileStyle = true;
            this.addListeners(true);
        } else if (!mq.matches && this.isMenuMobileStyle) {
            this.isMenuMobileStyle = false;
            this.addListeners(false);
        }
    }

    handleKeydown(event) {
        // event.preventDefault();

        var tgt = event.currentTarget,
          char = event.key,
          flag = false,
          clickEvent;
      
        function isPrintableCharacter (str) {
          return str.length === 1 && str.match(/\S/);
        }
      
        switch (event.keyCode) {
            case keyCode.SPACE:
            case keyCode.RETURN:
            case keyCode.DOWN:
                if (this.popupMenu) {
                    this.popupMenu.open();
                    this.popupMenu.setFocusToFirstItem();
                    flag = true;
                }
                break;
        
            case keyCode.LEFT:
                this.menu.setFocusToPreviousItem(this);
                flag = true;
                break;
        
            case keyCode.RIGHT:
                this.menu.setFocusToNextItem(this);
                flag = true;
                break;
        
            case keyCode.UP:
                if (this.popupMenu) {
                    this.popupMenu.open();
                    this.popupMenu.setFocusToLastItem();
                    flag = true;
                }
                break;
        
            case keyCode.HOME:
            case keyCode.PAGEUP:
                this.menu.setFocusToFirstItem();
                flag = true;
                break;
        
            case keyCode.END:
            case keyCode.PAGEDOWN:
                this.menu.setFocusToLastItem();
                flag = true;
                break;
        
            case keyCode.TAB:
                if (this.popupMenu) {
                    this.popupMenu.close(true);
                }
                break;
        
            case keyCode.ESC:
                if (this.popupMenu) {
                    this.popupMenu.close(true);
                }
                break;
        
            default:
                if (isPrintableCharacter(char)) {
                    this.menu.setFocusByFirstCharacter(this, char);
                    flag = true;
                }
                break;
        }
      
        if (flag) {
            event.stopPropagation();
            event.preventDefault();
        }
    }
      
    setExpanded(value) {
        if (value) {
            this.domNode.setAttribute('aria-expanded', 'true');
        } else {
            this.domNode.setAttribute('aria-expanded', 'false');
        }
    }
      
    handleFocus(event) {
        this.menu.hasFocus = true;
        if (this.popupMenu) {
            this.popupMenu.open();
        }
    }
      
    handleBlur(event) {
        this.menu.hasFocus = false;
    }
      
    handleMouseover(event) {
        this.hasHover = true;
        if (this.popupMenu) {
            // this.popupMenu.open();
            setTimeout(function () {
                if (this.hasHover) { this.popupMenu.open(); }
            }.bind(this, false), 200);
        }
    }
      
    handleMouseout(event) {
        this.hasHover = false;
        if (this.popupMenu) {
            // this.popupMenu.close(true);
            setTimeout(this.popupMenu.close.bind(this.popupMenu, false), 50);
        }
    }

    handleClick(event) {
        event.preventDefault();
        event.stopPropagation();

        if (this.popupMenu) {
            this.popupMenu.open();
        } else {
            this.menu.close();
        }
    }

    handleESCPress(event) {
        switch (event.keyCode) {
            case keyCode.ESC:
                event.stopPropagation();
                event.preventDefault();

                if (this.popupMenu) {
                    this.popupMenu.close(true);
                }
                break;
        
            default:
                break;
        }
    }
}

export default MenubarItem;